<template>
    <div class="relative overflow-x-hidden">
        <jet-authentication-card>
            <template #logo>
                <jet-authentication-card-logo />

                <h1
                    class="font-semibold text-iron-900 mt-[26px] text-center text-[26px] tracking-[-0.1px]"
                >
                    {{ $t("auth.login.title") }}
                </h1>
                <p class="text-sm font-medium text-iron-500 text-center">
                    {{ $t("auth.login.description") }}
                </p>
            </template>

            <jet-validation-errors class="mb-4" />

            <div v-if="status" class="mb-4 text-sm font-medium text-green-600">
                {{ status }}
            </div>

            <form @submit.prevent="submit">
                <div>
                    <jet-input
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="block w-full"
                        :placeholder="$t('auth.login.enter_email')"
                        required
                        autofocus
                    />
                </div>

                <div class="mt-5">
                    <jet-input
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="block w-full"
                        :placeholder="$t('auth.login.enter_password')"
                        required
                        autocomplete="current-password"
                    />
                </div>

                <div class="mt-5 flex justify-between">
                    <label class="flex items-center">
                        <jet-checkbox
                            v-model:checked="form.remember"
                            name="remember"
                        />
                        <span class="ml-2 text-sm font-medium text-iron-700">{{
                            $t("auth.login.remember_me")
                        }}</span>
                    </label>

                    <inertia-link
                        v-if="canResetPassword"
                        :href="
                            route('password.request') +
                            ($page.props.locale !== 'cs-CZ'
                                ? ''
                                : '?locale=cs-CZ')
                        "
                        class="text-sm font-medium text-z-primary-600 hover:opacity-75"
                        >{{ $t("auth.login.forgot_password") }}</inertia-link
                    >
                </div>

                <div class="mt-5 flex items-center justify-end">
                    <!-- <button
                    id="login-button"
                    class="inline-flex w-full justify-center items-center px-4 py-3 bg-iron-800 border border-transparent rounded-md font-semibold text-sm text-white tracking-widest hover:bg-iron-700 active:bg-iron-900 focus:outline-none focus:border-iron-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    {{ $t("auth.login.log_in") }}
                </button> -->

                    <ThemedButton class="flex w-full justify-center">
                        {{ $t("auth.login.log_in") }}
                    </ThemedButton>
                </div>
            </form>

            <SSOSignIn
                :locale="$page.props.locale !== 'cs-CZ' ? 'en-US' : 'cs-CZ'"
            />

            <template #under>
                <p class="mt-8 text-sm text-iron-500 text-center">
                    {{ $t("auth.login.not_a_member") }}
                    <!-- space -->
                    <a
                        :href="
                            '/register' +
                            ($page.props.locale !== 'cs-CZ'
                                ? ''
                                : '?locale=cs-CZ')
                        "
                        class="font-semibold leading-6 text-z-primary-600 hover:opacity-75"
                    >
                        {{ $t("auth.login.sign_up_here") }}
                    </a>
                </p>
            </template>
        </jet-authentication-card>
    </div>
</template>

<script lang="ts" setup>
import JetAuthenticationCard from "../../Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "../../Jetstream/AuthenticationCardLogo.vue";
import JetInput from "../../Jetstream/Input.vue";
import JetCheckbox from "../../Jetstream/Checkbox.vue";
import JetValidationErrors from "../../Jetstream/ValidationErrors.vue";
import SSOSignIn from "./components/SSOSignIn.vue";
import { useForm, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";
import ThemedButton from "../Zaptime/App/Atomic/ThemedButton.vue";
import { useAffiliate } from "@/composables/useAffiliate";
import { useAnalytics } from "@/composables/useAnalytics";

defineProps({
    canResetPassword: Boolean,
    status: String,
});

const form = useForm({
    email: "",
    password: "",
    remember: false,
});

useAffiliate();

const page = usePage();
const analytics = useAnalytics();

const submit = function () {
    form.transform((data) => ({
        ...data,
        remember: form.remember ? "on" : "",
    })).post(route("login"), {
        onSuccess: function () {
            const userId = page.props.userId as string | null;
            const user = page.props.user as Record<string, any> | null;
            if (userId && user) {
                analytics.identifyUser(String(userId), {
                    email: user.email,
                    name: user.name,
                });
            }
        },
        onFinish: function () {
            form.reset("password");
        },
    });
};
</script>
